import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import {
  formatDurationSeconds,
  formatUptimePercent,
} from "@/v2-backoffice-client/uptime/uptime.utils"
import type { UptimeViewDetailQuery } from "@/v2-backoffice-client/uptime/view/detail/__types__/uptime.view.detail.query"

export type UptimeViewAvailabilityProps = ComponentProps<"table"> & {
  rows: UptimeViewDetailQuery["getUptimeTargetAvailability"]
}

const PERIOD_LABELS: Record<string, string> = {
  today: "Today",
  "7d": "Last 7 days",
  "30d": "Last 30 days",
  "365d": "Last 365 days",
  all: "All time",
}

function UptimeViewAvailability(props: UptimeViewAvailabilityProps) {
  const { rows, className, ...tableProps } = props

  return (
    <table
      className={cn("uptime-view-availability-table", className)}
      {...tableProps}
    >
      <thead>
        <tr>
          <th>Time period</th>
          <th className="num">Availability</th>
          <th className="num">Downtime</th>
          <th className="num">Incidents</th>
          <th className="num">Longest incident</th>
          <th className="num">Avg incident</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.Period}>
            <td>{PERIOD_LABELS[r.Period] ?? r.Period}</td>
            <td className="num">
              {formatUptimePercent(r.AvailabilityPercent, "no data")}
            </td>
            <td className="num">
              {r.DowntimeSeconds > 0
                ? formatDurationSeconds(r.DowntimeSeconds)
                : "none"}
            </td>
            <td className="num">{r.IncidentCount}</td>
            <td className="num">
              {r.LongestIncidentSeconds != null
                ? formatDurationSeconds(r.LongestIncidentSeconds)
                : "none"}
            </td>
            <td className="num">
              {r.AvgIncidentSeconds != null
                ? formatDurationSeconds(r.AvgIncidentSeconds)
                : "none"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default UptimeViewAvailability
